import { database } from "../firebase";

export const fetchAllEmailTemplates = async (info) => {
  try {
    const templatesList = [];
    const allTemplates = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("templates")
      .where("type", "==", "email")
      .get();
    if (allTemplates.size > 0) {
      allTemplates.forEach((template) => {
        const single = fetchEmailTemplate(template.id, template.data());
        templatesList.push(single);
      });
    }
    return Promise.all(templatesList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchEmailTemplate = (templateId, template) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(template.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            id: templateId,
            type: template.type ? template.type : null,
            title: template.title ? template.title : null,
            timestamp: template.timestamp ? template.timestamp : null,
            lastUpdated: template.lastUpdated ? template.lastUpdated : null,
            html: template.html ? template.html : null,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchAllSMSTemplates = async (info) => {
  try {
    const clientList = [];
    const allClients = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("templates")
      .where("type", "==", "sms")
      .get();
    if (allClients.size > 0) {
      allClients.forEach((template) => {
        const single = fetchSMSTemplate(template.id, template.data());
        clientList.push(single);
      });
    }
    return Promise.all(clientList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchSMSTemplate = (templateId, template) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(template.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            id: templateId,
            type: template.type ? template.type : null,
            title: template.title ? template.title : null,
            timestamp: template.timestamp ? template.timestamp : null,
            lastUpdated: template.lastUpdated ? template.lastUpdated : null,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
            message: template.message ? template.message : null,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteSingleTemplate = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("templates")
      .doc(info.key)
      .delete();
    return { error: null, payload: info.type };
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteMultipleTemplatesArray = async (details) => {
  try {
    if (details && details.items.length > 0) {
      const deletions = [];
      details.items.forEach((key) => {
        const single = deleteTemplate({
          companyId: details.companyId,
          key: key,
        });
        deletions.push(single);
      });

      return Promise.all(deletions).then((result) => {
        return { error: null };
      });
    } else {
      throw new Error("Kunne ikke slette maler.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteTemplate = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("templates")
      .doc(details.key)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
